(() => {
  const requests = new Map();
  function selection(path, order) {
    const url = new URL(path, location.origin);
    url.searchParams.set('view', 'namorra-card-image');
    url.searchParams.set('sort_by', order);
    const key = url.href;
    if (!requests.has(key)) requests.set(key, fetch(url, {
      credentials: 'same-origin', headers: {Accept: 'text/html'}
    }).then(response => {
      if (!response.ok) throw new Error('Collection image unavailable');
      return response.json();
    }));
    return requests.get(key);
  }
  async function update(card) {
    if (card.dataset.autoImageInitialized) return;
    card.dataset.autoImageInitialized = 'true';
    try {
      let chosen = await selection(card.dataset.autoCollectionImage, 'best-selling');
      let reason = 'bestseller';
      if (!chosen.has_sales || !chosen.image) {
        chosen = await selection(card.dataset.autoCollectionImage, 'created-descending');
        reason = 'newest';
      }
      if (!chosen.image) {card.dataset.autoImageInitialized = 'empty'; return;}
      const container = card.querySelector('[data-auto-image-container]');
      if (!container) return;
      let image = container.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.alt = ''; image.loading = 'lazy';
        container.replaceChildren(image);
      }
      const source = new URL(chosen.image.src, location.origin);
      if (source.protocol !== 'https:') return;
      image.srcset = chosen.image.small + ' 320w, ' + chosen.image.medium + ' 640w, ' + chosen.image.src + ' 900w';
      image.sizes = '(min-width: 1100px) 31vw, (min-width: 750px) 45vw, 92vw';
      image.width = chosen.image.width;
      image.height = chosen.image.height;
      image.src = source.href;
      card.dataset.imageProduct = chosen.product || '';
      card.dataset.imageSelection = reason;
      card.dataset.autoImageInitialized = 'complete';
    } catch (_) {
      // The server-rendered fallback is already a product from this collection.
      card.dataset.autoImageInitialized = 'fallback';
    }
  }
  async function init() {
    const cards = Array.from(document.querySelectorAll('[data-auto-collection-image]'));
    for (let offset = 0; offset < cards.length; offset += 3) {
      await Promise.allSettled(cards.slice(offset, offset + 3).map(update));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();